"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _DownloadingAnswersViewStyle = _interopRequireDefault(require("../css/DownloadingAnswersViewStyle"));

var _svgIcons = _interopRequireDefault(require("../css/svg-icons"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var DownloadingAnswersView = function DownloadingAnswersView(_ref) {
  var viewData = _ref.viewData,
      printPdf = _ref.printPdf;
  (0, _react.useEffect)(function () {
    document.querySelector('.wrapper .text-box .green-color a').addEventListener('click', function (e) {
      e.preventDefault();
      printPdf();
    });
    document.querySelector('.wrapper .text-box p:not(.green-color) a').classList.add('link');
    typeof dataLayer !== 'undefined' ? dataLayer.push({
      'event': 'vpv',
      'vpv': "".concat(window.location.href, "/download-as-a-pdf-file/step6")
    }) : null;
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_DownloadingAnswersViewStyle["default"], null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "downloading-answers-view"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "top-wrapper",
    dangerouslySetInnerHTML: {
      __html: viewData.downloadingAnswersView.downloadHeadline.html.html
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "wrapper"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "image",
    dangerouslySetInnerHTML: {
      __html: _svgIcons["default"].download
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-box",
    dangerouslySetInnerHTML: {
      __html: viewData.downloadingAnswersView.downloadDescription.html.html
    }
  }))));
};

var _default = DownloadingAnswersView;
exports["default"] = _default;